export type CopyTemplateMissingInfo = {
    missingPatient: boolean
    missingAppointment: boolean
}

export function getCopyTemplateMissingInfoHelp({
    missingPatient,
    missingAppointment,
}: CopyTemplateMissingInfo): string | undefined {
    if (missingPatient && missingAppointment) {
        return 'You must select a patient and an appointment to fill patient and appointment tags.'
    }

    if (missingPatient) {
        return 'You must select a patient to fill patient tags.'
    }

    if (missingAppointment) {
        return 'You must select an appointment to fill appointment tags.'
    }

    return undefined
}
